export const getLangFromPath = (pathname) => {
    if (pathname.startsWith("/es")) {
        return "es";
    }

    if (pathname.startsWith("/ru")) {
        return "ru";
    }

    return "ua";
};

export const getCanonicalUrl = (pathname) => {
    const siteUrl = "https://enter.abp.ua";

    if (pathname === "/") {
        return `${siteUrl}/`;
    }

    return `${siteUrl}${pathname}`;
};
